<template>
    <oss-dialog
        v-model="dialog"
        :minWidth="step === 'sepa' ? '1200px' : '800px'"
        :title="title"
        :valid-title="step === 'dates' ? 'Suivant' : 'Valider'"
        :valid-disabled="validDisabled"
        :validLoading="validLoading"
        :previousDisplay="step === 'sepa'"
        @valid="nextStep"
        @previous="previousStep"
        :actions="actions"
    >
        <v-window v-model="step">
            <v-window-item :value="'dates'">
                <v-form v-model="formIsValid">
                    <v-row>
                        <v-col>
                            <oss-date-picker-filled
                                v-model="startDate"
                                hide-details
                                :textFieldReadOnly="false"
                            >
                            </oss-date-picker-filled>
                        </v-col>
                        <v-col>
                            <oss-date-picker-filled
                                v-model="endDate"
                                hide-details
                                class="pl-2"
                                :textFieldReadOnly="false"
                            >
                            </oss-date-picker-filled>
                        </v-col>
                    </v-row>
                </v-form>
            </v-window-item>
            <v-window-item :value="'sepa'">
                <Sepa
                    :companyId="companyId"
                    :filteredThirdPartyCompanies="filteredThirdPartyCompanies"
                    :startDate="startDate"
                    :endDate="endDate"
                    :accountableAccount="accountableAccount"
                    :actions="sepaActions"
                    v-if="step === 'sepa'"
                    @onUpdated="onActionDone()"
                >
                </Sepa>
            </v-window-item>
        </v-window>
    </oss-dialog>
</template>

<script lang="ts">
import _ from "lodash";
import moment from "moment-timezone";
import { DialogAction } from "../../services/dialogAction";
import Sepa from "./Sepa.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";

//

@Component({
    components: {
        Sepa,
    },
})
export class SepaAuto extends Vue {
    @Prop({ required: true }) readonly companyId: string;
    @Prop({ default: "411000" }) readonly accountableAccount: string;
    @Prop({ default: null }) readonly filteredThirdPartyCompanies: any;

    @Model() value: boolean;

    formIsValid: boolean = false;

    get title() {
        if (this.accountableAccount?.startsWith("411")) {
            return "Prélèvement";
        }
        return "Virement";
    }

    get description() {
        if (this.accountableAccount?.startsWith("411")) {
            return "Uniquement les clients en règlement par prélèvement";
        }
        if (this.accountableAccount?.startsWith("401")) {
            return "Uniquement les fournisseurs en règlement par virement";
        }
        return "Règlement des personnes par virement";
    }

    step = "dates";

    startDate = moment().add(-1, "month").startOf("month").format("YYYY-MM-DD");
    endDate = moment().add(-1, "month").endOf("month").format("YYYY-MM-DD");

    sepaActions = {
        action: new DialogAction(),
    };

    get actions() {
        if (this.step === "dates") {
            return null;
        }
        return this.sepaActions;
    }

    validLoading: boolean = false;

    get validDisabled() {
        if (!this.formIsValid) {
            return true;
        }
        return false;
    }

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    nextStep() {
        this.step = "sepa";
    }

    previousStep() {
        this.step = "dates";
    }

    onActionDone() {
        this.dialog = false;
    }
}

export default toNative(SepaAuto);
</script>
